module.exports = __webpack_public_path__ + "img/report3-4.16b65541.png";